import React, { useEffect, useRef, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Card } from 'primereact/card';
import PatientCarusel from './patientCarusel';
import "./patients.css";
import AddPatientDialog from '../Utils/AddPatientDialog/addPatientDialog';
import { BlockUI } from 'primereact/blockui';
import PatientTable from './patientTable';
import { LazyParams } from '../services/lazyParams';
import { useGetPatientListQuery, useGetPatientNewListQuery } from '../hooks/useGetDataQuery';
import { formatNameAndSurname } from '../Utils/format';


const Patients = () => {

    const {
        mutate: getPatientNewListMutation,
        data: patientNewListData,
        isError: isErrorPatientNewList,
        isSuccess: isSuccessPatientNewList,
    } = useGetPatientNewListQuery();

    const {
        mutate: getPatientListMutation,
        data: patientListData,
        isError: isErrorPatientList,
        isSuccess: isSuccessPatientList,
    } = useGetPatientListQuery();

    const { t }: any = useOutletContext();
    const { patientNewList }: any = useOutletContext();
    const { setPatientNewList }: any = useOutletContext();

    const { patientList }: any = useOutletContext();
    const { setPatientList }: any = useOutletContext();

    const [blockPatientNewTable, setBlockPatientNewTable] = useState<any>();
    const [blockPatientTable, setBlockPatientTable] = useState<any>();

    const [patientNewListCount, setPatientNewListCount] = useState<any>();
    const [patientListCount, setPatientListCount] = useState<any>();

    const [addPatientDialogVisible, setAddPatientDialogVisible] = useState(false);
    const [caruselPatients, setCaruselPatients] = useState<any>([]);

    const [lazyParamsForPatientNewList, setLazyParamsForPatientNewList] = useState<LazyParams>({
        first: 0,
        rows: 10,
        page: 0,
        sortField: "dateCreated",
        sortOrder: -1,
        filters: {
            name: {
                matchMode: "contains",
                value: ""
            }

        },
    });

    const [lazyParamsForPatientList, setLazyParamsForPatientList] = useState<LazyParams>({
        first: 0,
        rows: 10,
        page: 0,
        sortField: "dateCreated",
        sortOrder: -1,
        filters: {
            name: {
                matchMode: "contains",
                value: ""
            }
        },
    });

    useEffect(() => {
        setBlockPatientNewTable(true)
        getPatientNewListMutation(lazyParamsForPatientNewList)
    }, [lazyParamsForPatientNewList]);

    useEffect(() => {
        setBlockPatientTable(true)
        getPatientListMutation(lazyParamsForPatientList)
    }, [lazyParamsForPatientList]);

    useEffect(() => {
        if (isSuccessPatientNewList) {
            let purifiedData = (patientNewListData as any)?.data?.patients.map((patient: any) => ({
                ...patient,
                dateCreated: new Date(patient.dateCreated),
                firstName: formatNameAndSurname(patient.firstName),
                lastName: formatNameAndSurname(patient.lastName),
            }));
            setPatientNewListCount((patientNewListData as any)?.data?.count)
            setPatientNewList(purifiedData)
            setBlockPatientNewTable(false)
        }
    }, [isSuccessPatientNewList]);

    useEffect(() => {
        if (isErrorPatientNewList) {
            setBlockPatientNewTable(false)
        }
    }, [isErrorPatientNewList]);

    useEffect(() => {
        if (isSuccessPatientList) {
            let purifiedData = (patientListData as any)?.data?.patients.map((patient: any) => ({
                ...patient,
                dateCreated: new Date(patient.dateCreated),
                firstName: formatNameAndSurname(patient.firstName),
                lastName: formatNameAndSurname(patient.lastName),
            }));
            setPatientListCount((patientListData as any)?.data?.count)
            setPatientList(purifiedData)
            setBlockPatientTable(false)
        }
    }, [isSuccessPatientList]);

    useEffect(() => {
        if (isErrorPatientList) {
            setBlockPatientTable(false)
        }
    }, [isErrorPatientList]);

    const ranOnce = useRef<boolean>(true);

    useEffect(() => {
        if (patientList?.length > 0 && ranOnce?.current) {

            const emptyPatient = {
                empty: true
            }

            if (patientList.length >= 3) {
                setCaruselPatients([...(patientList?.slice(0, 10) || [])]);
            }
            else {
                const tempPatientList: any = []
                for (let i = 0; i < 3; i++) {
                    if (patientList[i]) {
                        tempPatientList.push(patientList[i])
                    }
                    else {
                        tempPatientList.push(emptyPatient)
                    }
                }
                setCaruselPatients(tempPatientList)
            }
            ranOnce.current = false;
        }
    }, [patientList]);

    return (

        <div>
            <BlockUI
                blocked={blockPatientTable && ranOnce.current}
                style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                template={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <dotlottie-player
                            src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                            background="transparent"
                            speed="1"
                            style={{ width: "3rem", height: "3rem" }}
                            loop
                            autoplay
                        />
                    </div>
                }
            >
                <PatientCarusel caruselPatients={caruselPatients}
                    setAddPatientDialogVisible={setAddPatientDialogVisible} t={t} />
            </BlockUI>


            <div className='grid'>
                <div className='col-6'>
                    <BlockUI
                        blocked={blockPatientNewTable}
                        style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                        template={
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <dotlottie-player
                                    src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                                    background="transparent"
                                    speed="1"
                                    style={{ width: "3rem", height: "3rem" }}
                                    loop
                                    autoplay
                                />
                            </div>
                        }
                    >
                        <Card style={{ borderRadius: "24px", position: "relative" }} className='mt-3'>
                            <PatientTable
                                patientList={patientNewList}
                                patientListCount={patientNewListCount}
                                lazyParamsForPatientList={lazyParamsForPatientNewList}
                                setLazyParamsForPatientList={setLazyParamsForPatientNewList}
                                t={t}
                                mode={"newPatient"}
                                setPatientNewList={setPatientNewList}
                            />
                        </Card>
                    </BlockUI>
                </div>

                <div className='col-6'>
                    <BlockUI
                        blocked={blockPatientTable}
                        style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                        template={
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <dotlottie-player
                                    src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                                    background="transparent"
                                    speed="1"
                                    style={{ width: "3rem", height: "3rem" }}
                                    loop
                                    autoplay
                                />
                            </div>
                        }
                    >
                        <Card style={{ borderRadius: "24px", position: "relative" }} className='mt-3'>
                            <PatientTable
                                patientList={patientList}
                                patientListCount={patientListCount}
                                lazyParamsForPatientList={lazyParamsForPatientList}
                                setLazyParamsForPatientList={setLazyParamsForPatientList}
                                t={t}
                                mode={"patient"}
                                setPatientNewList={null}
                            />
                        </Card>
                    </BlockUI>
                </div>
            </div>


            <AddPatientDialog
                t={t}
                patientList={patientList}
                setPatientList={setPatientList}
                addPatientDialogVisible={addPatientDialogVisible}
                setAddPatientDialogVisible={setAddPatientDialogVisible}
            />
        </div>


    );

}

export default Patients